import styled from "styled-components";

export const Input = styled.input`
	width: ${(props) => props.width};
	border: 1px solid #d6d6d6;
	color: black;
	font-size: 16px;
	border-radius: 5px;
	height: 50px;
	text-align: center;
	position: relative;
    padding-left: 8px;
	padding-right: ${(props) => props.isPassword ? "48px" : ""};
`;

export const Radio = styled.input.attrs(({ type }) => ({
  type: "radio",
}))`
  width: 20px;
  cursor: pointer;
`;

export const CheckBox = styled.input.attrs(({ type }) => ({
  type: "CheckBox",
}))`
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: solid 1px red;
  margin-right: 10px;
`;
